import Button from '@/Components/Button'
import Input from '@/Components/Input'
import Label from '@/Components/Label'
import ValidationErrors from '@/Components/ValidationErrors'
import { showJSONData } from '@/helpers/example'
import { hasRole } from '@/helpers/user'
import Authenticated from '@/Layouts/Authenticated'
import { Link, useForm } from '@inertiajs/inertia-react'
import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select/creatable'

const Update = ({ store, auth, errors, user, roles, branchOffices }) => {
    console.log('los user roles', user.roles)
    console.log({auth, user})
    const { data, setData, put, processing, errors:formErrors, reset } = useForm({
        name: user.name,
        email: user.email,
        roles_form: user.roles,
        branch_office_id: user.branch_office_id,
        redelcom_terminal: user.redelcom_terminal,
        new_password: ''
    });
    // const handleRoleName = (role) => {
    //     switch (role){
    //         case 'super_admin':
    //             return 'Super Admin';
    //         case 'admin':
    //             return 'Administrador de sucursal';
    //         case 'validator':
    //             return 'Validador de tickets';
    //         default:
    //             return 'No hay roles';
    //     }
    // }

    const [optionsSelected, setOptionsSelected] = useState(user.roles.map(e => ({label: e.label, value: e.id, name: e.name})));

    const isAdminSelected = useMemo(() => {
        return optionsSelected.filter(option => option.name === 'admin').length > 0;
    }, [optionsSelected])

    const isCashboxOperatorSelected = useMemo(() => {
        return optionsSelected.filter(option => option.name === 'cashbox_operator').length > 0;
    }, [optionsSelected])

    useEffect(() => {
        return () => {
            reset('password', 'password_confirmation');
        };
    }, []);

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const submit = (e) => {
        e.preventDefault();
        put(route('users.update', {user: user.id}));
    };
    useEffect(() => {
        setData({
            ...data,
            'roles_form': optionsSelected ? optionsSelected.map(e => e.value) : [],
            redelcom_terminal: !isCashboxOperatorSelected ? '' : data.redelcom_terminal
        })
        console.log('opchon selected', optionsSelected)
    }, [optionsSelected])

    return (
        <Authenticated
            store={store}
            auth={auth}
            errors={errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight flex justify-between">
                <p>Editar usuario</p>
                {/* <Link href={route('branch-office.create')} className="px-3 py-2 bg-primary text-white rounded text-sm">Agregar nueva sucursal</Link> */}
            </h2>}
        >
            <div className="max-w-7xl flex flex-col sm:flex-row py-12 px-3 sm:px-6 lg:px-8 gap-8 mx-auto">
                <div className="sm:w-4/5 flex-col flex gap-3 ">
                    <ValidationErrors errors={formErrors} />

                    <form onSubmit={submit}>
                        <div>
                            <Label forInput="name" value="Nombre" />

                            <Input
                                type="text"
                                name="name"
                                value={data.name}
                                className="mt-1 block w-full"
                                autoComplete="name"
                                isFocused={true}
                                handleChange={onHandleChange}
                                required
                            />
                        </div>

                        <div className="mt-4">
                            <Label forInput="email" value="Email" />

                            <Input
                                type="email"
                                name="email"
                                value={data.email}
                                className="mt-1 block w-full cursor-not-allowed text-gray-500"
                                autoComplete="username"
                                handleChange={onHandleChange}
                                disabled={true}
                                title="No se puede cambiar el correo, le recomendamos crear una nueva cuenta"
                            />
                        </div>

                        {/* <div className="mt-4">
                            <Label forInput="password" value="Password" />

                            <Input
                                type="password"
                                name="password"
                                value={data.password}
                                className="mt-1 block w-full"
                                autoComplete="new-password"
                                handleChange={onHandleChange}
                                required
                            />
                        </div> */}

                        {/* <div className="mt-4">
                            <Label forInput="password_confirmation" value="Confirmar password" />

                            <Input
                                type="password"
                                name="password_confirmation"
                                value={data.password_confirmation}
                                className="mt-1 block w-full"
                                handleChange={onHandleChange}
                                required
                            />
                        </div> */}

                        <div className="mt-4">
                        <Label forInput="role" value="Nivel de acceso" />
                        <Select
                        
                            options={roles
                                .filter(role => {
                                    if (!hasRole(auth.user, 'super_admin')) {
                                        return role.name !== 'super_admin' && role.name !== 'admin'
                                    }

                                    return role.name !== 'super_admin'
                                })
                                .map(role => ({label: role.label, value: role.id, name: role.name}))
                            }
                            isMulti
                            isClearable
                            //menuIsOpen={false}
                            id="role"
                            styles={{
                                indicatorSeparator: () => ({ display: "none" }),
                                input: (styles) => ({
                                    ...styles,
                                    "> input": {
                                        boxShadow: "none !important",
                                    },
                                }),
                            }}
                            className="col-span-8 rounded-md shadow-none"
                            //onKeyDown={handleKeyDown}
                            //onInputChange={(newValue) => setSelectInputValue(newValue)}
                            onChange={(newValue) => {
                                console.log('el value del onchange',newValue)
                                setOptionsSelected(optionsSelected => [...newValue])
                            }}
                            value={ optionsSelected }
                            placeholder="Seleccione un rol."
                            noOptionsMessage={() =>
                                "No hay roles para asignar"
                            }
                        />
                        </div>

                        <div className="mt-4">
                            <Label forInput="branch_office_id" value="Sucursal" />
                            <Select
                                options={branchOffices.map(office => ({label: office.name, value: office.id}))}
                                //menuIsOpen={false}
                                id="branch_office_id"
                                styles={{
                                    indicatorSeparator: () => ({ display: "none" }),
                                    input: (styles) => ({
                                        ...styles,
                                        "> input": {
                                            boxShadow: "none !important",
                                        },
                                    }),
                                }}
                                className="col-span-8 rounded-md shadow-none"
                                //onKeyDown={handleKeyDown}
                                //onInputChange={(newValue) => setSelectInputValue(newValue)}
                                onChange={({ value }) => {
                                    setData('branch_office_id', value);
                                }}
                                defaultValue={user?.branch_office ? {
                                    label: user?.branch_office?.name,
                                    value: user?.branch_office?.id,
                                } : null}
                                isDisabled={!hasRole(auth.user, 'super_admin')}
                                placeholder="Seleccione una sucursal."
                                noOptionsMessage={() =>
                                    "No hay sucursales para asignar"
                                }
                            />
                        </div>
                        {
                            isCashboxOperatorSelected &&
                            <div className="mt-4">
                                <Label forInput="redelcom_terminal" value="ID Terminal Redelcom" />
                                <Input
                                    type="text"
                                    name="redelcom_terminal"
                                    value={data.redelcom_terminal}
                                    className="mt-1 block w-full"
                                    autoComplete="redelcom_terminal"
                                    handleChange={onHandleChange}
                                />
                            </div>
                        }

                        {hasRole(auth.user, 'super_admin') && (
                            <div className="mt-4">
                                <Label forInput="new_password" value="Nueva contraseña" />
                                <Input
                                    type="password"
                                    name="new_password"
                                    value={data.new_password}
                                    className="mt-1 block w-full"
                                    handleChange={onHandleChange}
                                />
                            </div>
                        )}

                        <div className="flex items-center justify-end mt-4">


                            <Button className="ml-4" processing={processing}>
                                Actualizar usuario
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Authenticated>
    )
}

export default Update
